<template>
  <div v-if="!loading">
    <v-container fluid>
      <v-card>
        <v-card-title>
          Základný resocializačný a výchovno vzdelávací program
          <v-btn icon @click="showInfo('zakladny_program')">
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <date-picker-programy v-model="form.datum_zaradenia" label="Dátum začiatku ZRaVVP"></date-picker-programy>
            </v-col>
            <v-col>
              <date-picker-programy v-model="form.datum_vyradenia"
                label="Dátum ukončenia ZRaVVP"></date-picker-programy>
            </v-col>
            <v-col>
              <v-text-field v-model="form.celkovy_pocet_absolvovanych_hodin" label="Celkový počet absolvovaných hodín"
                disabled />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Názov
                      </th>
                      <th class="text-left" width="5%">
                        Počet absolvovaných hodín
                      </th>
                      <th class="text-left">
                        Dôvod neabsolvovania stanoveného počtu hodín
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in form.zakladne_programy" :key="item.name">
                      <td>{{ item.nazov }}</td>
                      <td>
                        <v-text-field v-model="item.pocet_hodin" single-line />
                      </td>
                      <td>
                        <v-text-field v-model="item.dovod_neabsolvovania_stanoveho" single-line />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="my-5">
        <v-card-title>
          Špecializované resocializačné a výchovno vzdelávacie programy
          <v-btn icon @click="showInfo('specializovane_programy')">
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
          <v-btn class="ml-1" icon download rounded color="primary" href="/charakteristika_SRaVVP_final.pdf">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="width: 20%">
                    Názov
                  </th>
                  <th style="width: 20%">
                    Expertné posúdenie potreby programu
                  </th>
                  <th style="width: 20%">
                    Zaradený do ŠRaVVP
                  </th>
                  <th style="width: 20%">
                    Absolvoval ŠRaVVP
                  </th>
                  <th style="width: 20%">
                    Poznámky
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in form.specializovane_programy">
                  <tr :key="index">
                    <td>{{ item.nazov }}</td>

                    <td>
                      <v-slider v-model="item.expertne_posudenie" class="pt-3" :color="color(index, 1)" min="0"
                        max="100" thumb-label="always" />
                    </td>
                    <td>
                      <v-checkbox v-model="item.zaradeny_do_sravvp" />
                    </td>
                    <td>
                      <v-checkbox v-model="item.absolvoval" />
                    </td>
                    <td>
                      <v-text-field v-if="item.zaradeny_do_sravvp && !item.absolvoval"
                        v-model="item.dovod_neabsolvovania" single-line label="Dôvod neabsolvovania" />

                      <v-text-field v-if="
                        (!item.zaradeny_do_sravvp && isHighest(item)) ||
                        displayWarning(item)
                      " v-model="item.dovod_nezaradenia" single-line
                        label="Dôvod neabsolvovania stanoveného počtu hodín" />
                    </td>
                  </tr>
                  <tr v-show="item.zaradeny_do_sravvp" :key="index">
                    <td></td>
                    <td> <date-picker-programy v-model="item.datum_zaradenia"
                        label="Dátum začiatku ŠRaVVP"></date-picker-programy>
                    </td>
                    <td> <date-picker-programy v-model="item.datum_vyradenia"
                        label="Dátum ukončenia ŠRaVVP"></date-picker-programy>
                    </td>
                    <td>
                      <v-text-field v-model="item.pocet_hodin" label="Celkový počet absolvovaných hodín" />
                    </td>
                    <td></td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <v-card v-if="form.indication_scores">
        <v-card-title>Indikačný nástroj</v-card-title>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Názov
                  </th>
                  <th class="text-left">
                    Skóre
                  </th>
                  <th class="text-left">
                    Kompletné
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in form.indication_scores" :key="key">
                  <td>{{ key }}</td>

                  <td>
                    <v-slider v-model="item.score" class="pt-3" :color="color(key, 2)" min="0" max="100"
                      thumb-label="always" readonly />
                  </td>
                  <td>
                    <v-checkbox v-model="item.complete" readonly />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <v-layout v-if="!form.closed" pt-5>
        <v-btn class="ma-2" fixed right bottom dark rounded color="primary" @click="updateItem()">
          Uložiť
        </v-btn>
        <div class="flex-grow-1"></div>
      </v-layout>
    </v-container>

    <v-snackbar v-model="snackbar_saved" color="success" :timeout="3000">
      Uložené
      <v-btn text @click="snackbar_saved = false">
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_error" color="error" :timeout="5000">
      Chyba
    </v-snackbar>

    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ dialog_item.nazov }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-card>
          <v-card-text v-for="(item, index) in dialog_item.charakteristika" :key="index">
            {{ item }}
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="SocialneProgramy" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import FormSkeleton from "../components/FormSkeleton.vue";
import DatePickerProgramy from "@/components/DatePickerProgramy.vue";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "form-skeleton-component": FormSkeleton,
    DatePickerProgramy
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      charakteristika: [],
    },

    form: {
      id: null,
    },

    selects: {
      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
      ],
    },

    manual: {
      zakladny_program: {
        nazov: "Základný resocializačný a výchovno vzdelávací program",
        charakteristika: [
          "Dátum zaradenia – označí sa dátum realizácie prvej hodiny v module základného resocializačného a výchovno vzdelávacieho programu",
          "Dátum vyradenia – označí sa dátum realizácie poslednej hodiny v module základného resocializačného a výchovno vzdelávacieho programu",
          "Absolvoval – označí sa v prípade absolvovania modulu v stanovenom počte hodín",
          "Počet absolvovaných hodín – uvádza sa počet hodín ktoré odsúdený absolvoval v danom module",
          "Dôvod neabsolvovania stanoveného počtu hodín",
          "Uvádza sa písomne odôvodnenie neabsolvovania stanoveného počtu hodín (napr. PN, eskorty, odpor ods. voči téme a pod.)"
        ],
      },
      specializovane_programy: {
        nazov: "Špecializované resocializačné a výchovno vzdelávacie programy",
        charakteristika: [
          "Expertné posúdenie potreby programu – po kolektívnej dohode je určená potreba absolvovania daného programu",
          "Zaradený do ŠRaVVP - označí sa v prípade zaradenia do ŠRaVVP",
          "Absolvoval program - označí sa v prípade absolvovania programu stanovenom počte hodín",
          "Poznámky – priestor pre informácie a zdôvodnenia pri nezaradení a neabsolvovaní programu v prípade indikácie (určenia potreby realizovať program)"
        ],
      },

    },
  }),

  computed: {},

  created() {
    this.getItem();
  },

  methods: {
    showInfo(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },

    displayWarning(item) {
      if (item.zaradeny_do_sravvp) return false;

      const sorted = [...this.form.specializovane_programy].sort(
        (a, b) => b.expertne_posudenie - a.expertne_posudenie
      );

      const itemIndex = sorted.findIndex((x) => x === item);

      if (itemIndex < 2 && sorted[2].zaradeny_do_sravvp) return true;

      return false;
    },

    isHighest(item) {
      var highest = Math.max.apply(
        Math,
        this.form.specializovane_programy.map(function (o) {
          return o.expertne_posudenie;
        })
      );

      if (highest == item.expertne_posudenie) return true;

      return false;
    },
    color(index, type) {
      var value = 0
      if (type == 1)
        value = this.form.specializovane_programy[index].expertne_posudenie;
      else
        value = this.form.indication_scores[index].score

      if (value <= 20) return "red";
      else if (value <= 50) return "orange";
      else if (value <= 80) return "blue";
      else return "green";
    },

    getItem() {
      this.loading = true;
      apiService.getSocialneProgramy(this.$route.params.id).then((response) => {
        this.form = response;
        this.loading = false;
      });
    },

    updateItem() {
      apiService.updateSocialneProgramy(this.form, this.$route.params.id).then(
        (response) => {
          this.snackbar_saved = true;
          this.form = response;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
  },
};
</script>